import { render, staticRenderFns } from "./lottery-time-section.vue?vue&type=template&id=0337d720&scoped=true&"
var script = {}
import style0 from "./lottery-time-section.vue?vue&type=style&index=0&id=0337d720&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337d720",
  null
  
)

export default component.exports